import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

// Fullscreen certificate lightbox.
export default function Lightbox({ open, image, title, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    if (open) {
      document.addEventListener("keydown", onKey);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="cert-lightbox"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          onClick={onClose}
          className="fixed inset-0 z-[100] grid place-items-center bg-background/90 backdrop-blur-md p-4 md:p-10"
        >
          <button
            data-testid="cert-lightbox-close"
            onClick={onClose}
            aria-label="Close certificate"
            className="absolute top-5 right-5 w-11 h-11 grid place-items-center border border-border rounded-full text-foreground hover:border-accent hover:text-accent transition-colors"
          >
            <X size={18} />
          </button>
          <motion.figure
            initial={{ scale: 0.94, y: 16 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.94, y: 16 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="max-w-[1100px] w-full"
          >
            <img
              src={image}
              alt={title}
              className="w-full h-auto max-h-[80vh] object-contain rounded-lg ring-1 ring-accent/40 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.8)]"
            />
            <figcaption className="mt-4 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
              {title}
            </figcaption>
          </motion.figure>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
